<div class="evidence-container">

  <div class="validation-modal-header">
    <div class="header-info">
      <h3>Programación Externa</h3>
      <h2>Subir Imagen de la Programación</h2>
    </div>
    <button type="button" class="btn-close-custom" (click)="onCancel()">
      <i class="material-icons">close</i>
    </button>
  </div>

  <p class="mt-2" style="color: var(--gl-text-secondary);">
    Cargue una imagen clara de la programación y valide que las unidades generadas coincidan con ella.
  </p>

  <form [formGroup]="bulkEditor.uploadImageform" (ngSubmit)="onSubmit()">
    <!-- Inputs Section -->
    <div class="header">
      <div class="mb-3">
        <label class="fw-bold text-form-label mb-1" style="font-size: 1rem;">
          Nombre de la Programación <span class="text-danger">*</span>
        </label>
        <input
          class="text-input-clean"
          type="text"
          [class.is-invalid]="submitted && f.name?.invalid"
          formControlName="name"
          placeholder="Escribe el nombre de la programación..."
        >
        <div *ngIf="submitted && f.name?.hasError('required')" class="validation-error-msg">
          El nombre del grupo es obligatorio
        </div>
      </div>
    </div>

    <!-- Single Image Upload Area -->
    <div
      *ngIf="!hasFile"
      class="upload-area"
      [class.dragging]="dragging"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      [class.is-invalid]="submitted && f.file?.invalid"
    >
      <input
        type="file"
        accept="image/*"
        #fileInput
        hidden
        (change)="onFileSelected($event)"
      />

      <div class="upload-content" (click)="fileInput.click()">
        <i class="material-icons upload-icon">cloud_upload</i>
        <p>Subir Imagen de Programación</p>
        <small>Arrastre la imagen aquí o haga clic para seleccionar</small>
        <div *ngIf="submitted && f.file?.hasError('required')" class="validation-error-msg justify-content-center">
          La imagen es obligatoria
        </div>
      </div>
    </div>

    <!-- Single Image Preview & Info -->
    <div class="evidence-list" *ngIf="file && filePreview">
      <div class="list-header">
        <h3 class="text-form-label ">Archivo Seleccionado</h3>
        <button class="clear-btn" type="button" (click)="removeFile()">Cambiar Imagen</button>
      </div>

      <div class="evidence-item">
        <div class="preview-section">
          <img [src]="filePreview" alt="preview" class="preview" />
          <div class="info">
            <span class="file-name">{{ file.name }}</span>
            <span class="file-size">{{ fileSizeLabel }}</span>
          </div>
        </div>

        <div class="status-section">
          <button class="delete-btn" type="button" (click)="removeFile()">
            <i class="material-icons">delete</i>
          </button>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="mb-3 border-top text-end d-flex justify-content-end gap-2 mt-4">
      <button type="button" class="btn btn-standar"(click)="onCancel()">
        Cancelar
      </button>
      <button class="btn btn-standar btn-standar-success"
        type="submit">
        <i class="material-icons" style="font-size: 18px;">cloud_done</i> Subir Programación
      </button>
    </div>
  </form>


</div>
